module.exports = __webpack_public_path__ + "img/1549493045.28daa567.jpg";